import React from 'react';
import { useRouteError } from 'react-router-dom';
import ErrorFallback from './ErrorFallback';

// Used as errorElement in React Router v6 routes.
// React Router only activates errorElement when an error has been caught,
// so error will always be defined in production. The undefined guard below
// handles the edge case of accidental rendering outside an error context.
function RouteErrorBoundary() {
  const error = useRouteError();
  const normalizedError = error instanceof Error
    ? error
    : new Error(error != null ? String(error) : 'An unknown error occurred');
  return <ErrorFallback error={normalizedError} />;
}

export default RouteErrorBoundary;
